import React from "react";
import { connect } from "react-redux";
import Latex from "../latex";
import { AppState } from "../../reducers";
import ProgressBar from "../ProgressBar";
import ViewQuestion from "./viewQuestion";

const FinishedQuiz = (props) => {
  const {
    answers,
    attempts,
    flags,
    inProgress,
    setIdx,
    finalIdx,
    setQIndex,
    progressStatus,
    data,
  } = props;
  return (
    <React.Fragment>
      <Latex>
        <div className="resultScreen">
          <h3 className="progress-align progress_title">Results</h3>
          {inProgress ? (
            <div>
              <div className="progress-align progress_subtitle">
                Assignment Complete. Results are being recorded.
              </div>
              <ProgressBar progressStatus={progressStatus} />
            </div>
          ) : (
            <ViewQuestion
              totalQst={data.questions.length}
              answers={answers}
              attempts={attempts}
              flags={flags}
              setQIndex={setQIndex}
              questions={data.questions}
              setIdx={setIdx}
              finalIdx={finalIdx}
            />
          )}
        </div>
      </Latex>
    </React.Fragment>
  );
};

const mapStateToProps = (store: AppState) => ({
  answers: store.quiz.answers,
  attempts: store.quiz.attempts,
  data: store.quiz.data,
  flags: store.quiz.flags,
});

export default connect(mapStateToProps)(FinishedQuiz);
